import NewOrganizationModalReducer from './NewOrganizationModalReducer';

export default from './NewOrganizationModalContainer';

export const NewOrganizationModalReducers = {
  NewOrganizationModalReducer,
};
